const merchantTap_icon =
  "https://file-th.ypkclient.com/system/20230915/3cb97a40f90d4e6db666d4928c5ccf2b.png";
const merchantTap_icon_active =
  "https://file-th.ypkclient.com/system/20230915/60a19cd2d09740f0883a35146f38a818.png";

const merchantTapRoute: IRouteProps[] = [
  {
    path: "/merchantTap",
    name: "商家TAP活动配置",
    meta: { icon: merchantTap_icon, activeIcon: merchantTap_icon_active },
    component: "./merchantTap/merchantTap"
  },
];

export default merchantTapRoute;
